export const PROFILE_TAB_LABEL_MAP = {
  "1": "pages.profile.showTrainScheme",
  "2": "pages.profile.showStatusAndForecasting",
  "3": "pages.profile.showTableData",
  "4": "pages.profile.showMeasureData",
} as const;

export const COLUMN_COUNT_OPTIONS = [1, 2, 3, 4] as const;

export const PROFILE_TAB_NAME_MAP = {
  "1": "showTrainScheme",
  "2": "showStatusAndForecasting",
  "3": "showTableData",
  "4": "showMeasureData",
} as const;

export const PROFILE_TAB_FORM_NAME_MAP = PROFILE_TAB_NAME_MAP;

export const POPUP_MSG_MODE_OPTIONS = {
  ALWAYS: "0",
  NEVER: "1",
  ALWAYS_EXCEPT_RECORDER_MODE: "2",
} as const;

export const EQUIPMENT_STATE_DISPLAY_MODE_OPTIONS = {
  GOST: 0,
  TCI: 1,
  MODE: 2,
} as const;

export const MIN_RECORD_MODE_TIME_UPDATE = 5;
export const MAX_RECORD_MODE_TIME_UPDATE = 9999;

export const PROFILE_SETTINGS_LAYOUT_MAX_WIDTH = 1120;

export const PROFILE_SETTINGS_TAB_IDS = ["general", "scheme", "speed", "multiAnalysis", "additional"] as const;

export type ProfileSettingsTabId = (typeof PROFILE_SETTINGS_TAB_IDS)[number];

export const DEFAULT_PROFILE_SETTINGS_TAB: ProfileSettingsTabId = "general";

export const PROFILE_SETTINGS_TAB_MESSAGE_IDS: Record<ProfileSettingsTabId, string> = {
  general: "pages.profile.tabGeneral",
  scheme: "pages.profile.tabScheme",
  speed: "pages.profile.tabSpeed",
  additional: "pages.profile.tabAdditional",
  multiAnalysis: "pages.profile.tabMultiAnalysis",
};

export function isProfileSettingsTabId(value: string | undefined): value is ProfileSettingsTabId {
  return PROFILE_SETTINGS_TAB_IDS.includes(value as ProfileSettingsTabId);
}
